var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.198412 0.198412C0.46296 -0.0661372 0.891878 -0.0661372 1.15643 0.198412L7 6.04198L12.8436 0.198412C13.1081 -0.0661372 13.537 -0.0661372 13.8016 0.198412C14.0661 0.46296 14.0661 0.891878 13.8016 1.15643L7.95801 7L13.8016 12.8436C14.0661 13.1081 14.0661 13.537 13.8016 13.8016C13.537 14.0661 13.1081 14.0661 12.8436 13.8016L7 7.95801L1.15643 13.8016C0.891878 14.0661 0.46296 14.0661 0.198412 13.8016C-0.0661372 13.537 -0.0661372 13.1081 0.198412 12.8436L6.04198 7L0.198412 1.15643C-0.0661372 0.891878 -0.0661372 0.46296 0.198412 0.198412Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.cb0c33d888dca43e2128edd3049bfba8.svg";
export { ForwardRef as ReactComponent };